"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sub_events_1 = require("sub-events");
var moment = require("moment");
var AsciiHelper_1 = require("./AsciiHelper");
var LogLevelEnum = {
    'debug': 0,
    'info': 10,
    'error': 20
};
var Logger = /** @class */ (function () {
    function Logger(logLevel) {
        this.isBrowserLogger = typeof window !== "undefined";
        this.onLog = new sub_events_1.SubEvent();
        if (logLevel in LogLevelEnum) {
            this.logLevelInt = LogLevelEnum[logLevel];
        }
        else {
            this.logLevelInt = 0;
        }
        if (this.isBrowserLogger)
            (0, AsciiHelper_1.logAsciiLogo)();
    }
    Logger.prototype.log = function (message, logLevel) {
        if (logLevel === void 0) { logLevel = "info"; }
        if (logLevel in LogLevelEnum) {
            if (LogLevelEnum[logLevel] < this.logLevelInt)
                return;
        }
        var logItem = {
            message: message,
            level: logLevel
        };
        var formattedConsoleMessage = this.formatConsole(message, logLevel);
        if (logLevel == "error") {
            console.error.apply(console, formattedConsoleMessage);
        }
        else {
            console.log.apply(console, formattedConsoleMessage);
        }
        this.onLog.emit(logItem);
    };
    Logger.prototype.catch = function (error, contextPrefix) {
        var message = error.message;
        var errorString = "";
        if (contextPrefix)
            errorString += "".concat(contextPrefix, ": ");
        errorString += message ? message : error;
        this.log(errorString, "error");
    };
    Logger.prototype.debug = function (message) {
        var stringifiedMessage;
        if (typeof message == "string") {
            stringifiedMessage = message;
        }
        else if (typeof message == "object" && this.isBrowserLogger) {
            stringifiedMessage = JSON.stringify(message);
        }
        else {
            stringifiedMessage = JSON.stringify(message);
        }
        this.log(stringifiedMessage, "debug");
    };
    Logger.prototype.formatConsole = function (message, logLevel) {
        if (this.isBrowserLogger)
            return [
                "%cchariot.js %c[".concat(moment().format("MMMM Do YYYY, h:mm:ssa"), "] %c[").concat(logLevel, "]"),
                "color: #4040dc;",
                "color: #AB47BC;",
                "color: #EC407A;",
                message
            ];
        return [
            "\u001B[34m%s \u001B[32m%s \u001B[35m%s \u001B[0m%s",
            "chariot.js",
            moment().format("MMMM Do YYYY, h:mm:ss a"),
            logLevel,
            message
        ];
    };
    return Logger;
}());
exports.default = Logger;
